const locales = {
  ru: 'ru',
  en: 'en',
};

const uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;

export { locales, uuidRegex };
